(() => {
  const PRODUCT_IDS = {
    core: "10316215255377", // Kaiju -> 28 sticks
    kick: "10342454100305", // Kaiju Kick -> 12 sticks
    pack: "10448039706961", // Performance Pack -> ne pas afficher
  };

  const STICKS_BY_PRODUCT_ID = {
    [PRODUCT_IDS.core]: 28,
    [PRODUCT_IDS.kick]: 12,
  };

  /* -------------------------
     currency helpers (PATCH)
  ------------------------- */

  const isUkRegion = () => {
    const country = String(window.Shopify?.country || "").toUpperCase();
    const activeCurrency = String(
      window.Shopify?.currency?.active ||
      window.Shopify?.currency?.activeCurrency ||
      ""
    ).toUpperCase();
    const locale = String(
      window.Shopify?.locale ||
      document.documentElement.lang ||
      ""
    ).toLowerCase();

    return country === "GB" || activeCurrency === "GBP" || locale.includes("en-gb");
  };

  const formatCurrency = (amount) => {
    const currency =
      String(
        window.Shopify?.currency?.active ||
        window.Shopify?.currency?.activeCurrency ||
        "EUR"
      ).toUpperCase();

    try {
      const parts = new Intl.NumberFormat(undefined, {
        style: "currency",
        currency,
        currencyDisplay: "narrowSymbol",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).formatToParts(Number(amount));

      const symbol = parts.find((p) => p.type === "currency")?.value || "";
      const number = parts
        .filter((p) => p.type !== "currency")
        .map((p) => p.value)
        .join("")
        .trim();

      // UK: symbol before
      if (isUkRegion()) return `${symbol}${number}`.trim();

      // others: symbol after
      return `${number}${symbol}`.trim();
    } catch (_) {
      const n = Number(amount).toFixed(2);
      if (currency === "GBP") return `£${n}`;
      if (currency === "USD") return `$${n}`;
      return `${n}€`;
    }
  };

  /* -------------------------
     utils existants
  ------------------------- */

  const moneyTextToNumber = (str) => {
    const s = String(str || "").trim();
    if (!s) return null;

    let cleaned = s.replace(/\s/g, "").replace(/[^\d,.-]/g, "");

    const lastComma = cleaned.lastIndexOf(",");
    const lastDot = cleaned.lastIndexOf(".");

    if (lastComma > -1 && lastDot > -1) {
      if (lastComma > lastDot) {
        cleaned = cleaned.replace(/\./g, "").replace(",", ".");
      } else {
        cleaned = cleaned.replace(/,/g, "");
      }
    } else if (lastComma > -1 && lastDot === -1) {
      cleaned = cleaned.replace(",", ".");
    }

    const n = Number(cleaned);
    return Number.isFinite(n) ? n : null;
  };

  const round2 = (n) => Math.round(n * 100) / 100;

  /* -------------------------
     per serving (PATCHED)
  ------------------------- */

  const formatPerStick = (price, sticksCount) => {
    const perServing = round2(price / sticksCount);
    return `${formatCurrency(perServing)} / serving`;
  };

  /* -------------------------
     product id resolution
  ------------------------- */

  const getKxoProductId = (kxoRoot) => {
    const fromSpan = kxoRoot
      .querySelector("[data-atc-perstick]")
      ?.getAttribute("data-product-id");
    if (fromSpan) return String(fromSpan);

    const fromAttr =
      kxoRoot.getAttribute("data-product-id") || kxoRoot.dataset.productId;
    if (fromAttr) return String(fromAttr);

    const jsonEl = kxoRoot.querySelector(
      'script[type="application/json"][data-kxo-product-json], script[data-kxo-product-json]'
    );
    if (jsonEl) {
      try {
        const data = JSON.parse(jsonEl.textContent || "{}");
        if (data && data.id) return String(data.id);
      } catch (_) {}
    }

    return "";
  };

  /* -------------------------
     main updater
  ------------------------- */

  const updateKxoModulePerStick = (kxoRoot) => {
    const productId = getKxoProductId(kxoRoot);
    const sticksCount = STICKS_BY_PRODUCT_ID[productId];

    const allPerStickEls = kxoRoot.querySelectorAll("[data-atc-perstick]");

    // pack / autres → cacher
    if (!sticksCount) {
      allPerStickEls.forEach((el) => {
        el.hidden = true;
        el.textContent = "";
      });
      return;
    }

    const subPriceEl = kxoRoot.querySelector('[data-kxo-price="subscription"]');
    const otPriceEl  = kxoRoot.querySelector('[data-kxo-price="onetime"]');

    const subPrice = moneyTextToNumber(subPriceEl?.textContent);
    const otPrice  = moneyTextToNumber(otPriceEl?.textContent);

    const subOption = kxoRoot
      .querySelector('input[type="radio"][value="subscription"]')
      ?.closest(".appstle_subscription_wrapper_option");

    const otOption = kxoRoot
      .querySelector('input[type="radio"][value="onetime"]')
      ?.closest(".appstle_subscription_wrapper_option");

    const subPerStickEl = subOption?.querySelector("[data-atc-perstick]");
    const otPerStickEl  = otOption?.querySelector("[data-atc-perstick]");

    if (subPerStickEl) {
      if (subPrice == null) {
        subPerStickEl.hidden = true;
        subPerStickEl.textContent = "";
      } else {
        const next = formatPerStick(subPrice, sticksCount);
        if (subPerStickEl.textContent !== next) subPerStickEl.textContent = next;
        subPerStickEl.hidden = false;
      }
    }

    if (otPerStickEl) {
      if (otPrice == null) {
        otPerStickEl.hidden = true;
        otPerStickEl.textContent = "";
      } else {
        const next = formatPerStick(otPrice, sticksCount);
        if (otPerStickEl.textContent !== next) otPerStickEl.textContent = next;
        otPerStickEl.hidden = false;
      }
    }

    // per-stick dans boutons internes KXO (ajax) → on cache
    kxoRoot.querySelectorAll(".kxo-atc [data-atc-perstick]").forEach((el) => {
      el.hidden = true;
      el.textContent = "";
    });
  };

  const updateAll = () => {
    document.querySelectorAll("[data-kxo-root]").forEach(updateKxoModulePerStick);

    // fallback boutons Shopify hors KXO
    document.querySelectorAll('button[id^="ProductSubmitButton-"]').forEach((btn) => {
      const perStickEl = btn.querySelector("[data-atc-perstick]");
      if (!perStickEl) return;

      const form = btn.closest("form") || btn.closest(".shopify-section") || document;
      if (form.querySelector("[data-kxo-root]")) return;

      const productId = String(perStickEl.getAttribute("data-product-id") || "");
      const sticksCount = STICKS_BY_PRODUCT_ID[productId];

      if (!sticksCount) {
        perStickEl.hidden = true;
        perStickEl.textContent = "";
        return;
      }

      const scope =
        btn.closest(".shopify-section") ||
        btn.closest("section") ||
        document;

      const priceEl =
        scope.querySelector(".price .price-item--sale") ||
        scope.querySelector(".price .price-item--regular") ||
        scope.querySelector(".price__container .price-item") ||
        scope.querySelector(".product__info-container .price .price-item");

      const price = moneyTextToNumber(priceEl?.textContent);
      if (price == null) {
        perStickEl.hidden = true;
        perStickEl.textContent = "";
        return;
      }

      const next = formatPerStick(price, sticksCount);
      if (perStickEl.textContent !== next) perStickEl.textContent = next;
      perStickEl.hidden = false;
    });
  };

  let raf = null;
  const scheduleUpdate = () => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = null;
      updateAll();
    });
  };

  const init = () => {
    updateAll();

    // warmup async
    let tries = 0;
    const warmup = () => {
      updateAll();
      tries += 1;
      if (tries < 90) requestAnimationFrame(warmup);
    };
    requestAnimationFrame(warmup);

    document.addEventListener("click", scheduleUpdate);
    document.addEventListener("change", scheduleUpdate);
    document.addEventListener("input", scheduleUpdate);

    const obs = new MutationObserver(scheduleUpdate);
    obs.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: [
        "checked",
        "value",
        "class",
        "style",
        "hidden",
        "aria-hidden",
      ],
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
